// @flow
import api from 'tim-api';
import TimSmartBlowFish from "@/utils/timsmartblowfish"

import {
  verifyUser,
  sendToken,
  auth,
  logout,
  reset,
  checkAllowedSystem,
  changePasswordFromInterface,
  enablePasswordChange
} from 'endPoints';
import BrowserStorage from '@/services/browser-storage';

type User = {
  registration: string,
  password: string,
  hash: string
};

export const state = {
  user: null,
  valueToChangePass: {},
  token: null
};

export const getters = {
  valueToChangePass: (state: Object) => state.valueToChangePass,
  user: ({ user }: Object) => (user && user) || null,
  username: ({ user }: Object) => (user && user.name) || null,
  registration: ({ user }: Object) => (user && user.registration) || null,
  role: ({ user }: Object) => (user && user.role) || null,
  email: ({ user }: Object) => (user && user.email) || null,
  idUser: ({ user }: Object) => (user && user.id) || null,
  isHQ: ({ user }: Object) => (user && user.role.name.includes('HQ')) || null,
  isDB: ({ user }: Object) => (user && user.role.slug.includes('TS011')) || null,
  getToken: ({ token }: Object) => token,
  webPermission: ({ user }: Object) => (
    user &&
    user.role &&
    user.role.permissions &&
    user.role.permissions
      .filter(permission => permission.permission.includes('web'))
      .map(permission => ({
        name: permission.permission,
        id: permission.id
      }))
  )
};

export const mutations = {
  SET_USER(state: Object, user: Object) {
    state.user = user;
  },
  SET_VALUE_TO_CHANGE_PASS(state: Object, valueToChangePass: Object) {
    state.valueToChangePass = valueToChangePass;
  },
  SET_TOKEN(state: Object, token: string) {
    state.token = token;
  },
};

export const actions = {
  login(context: Action, { registration, password, hash }: User) {
    if (hash) {
      return api.post(auth, { hash })
        .then(({ data }) => data || {});
    }

    return api.post(auth, { registration: TimSmartBlowFish.encode(registration), password: TimSmartBlowFish.encode(password) }).then(({ data }) => {
      const token = TimSmartBlowFish.decode(data.access_token);
      context.commit('SET_TOKEN', token);
      return { ...data, access_token: token };
    });
  },

  logout(context: Action, { }: Promise<{}>) {
    return api.post(logout);
  },

  verifyAccess({ commit }: Action): Promise<{}> {
    const recaptcha = BrowserStorage.get('recaptcha');
    return api.post(verifyUser, { recaptcha })
      .then((response) => {
        const stringObject = TimSmartBlowFish.decode(response.data.data);
        const userData = JSON.parse(stringObject);
        commit('SET_USER', userData);
        response.data.data = userData;
        return response;
      });
  },

  sendToken(context: Action, payload: Object) {
    return api.post(sendToken, payload)
      .then(({ data }) => data || {});
  },

  checkUser(context: Action, token: string) {
    return api.get(`${reset}/${token}`);
  },

  newPassword(context: Action, { token, body }: Object) {
    return api.post(`${reset}/${token}`, body)
      .then(({ data }) => data || {});
  },

  checkAllowedSystem({ commit }: Action, idSystem: string) {
    return api.post(`${checkAllowedSystem}`, { "idSystem": idSystem });
  },

  alterPassword(context: Action, { currentPassword, newPassword, newPasswordConfirm }: Object) {
    return api.post(`${changePasswordFromInterface}`, {
      "cp": TimSmartBlowFish.encode(currentPassword),
      "np": TimSmartBlowFish.encode(newPassword),
      "cnp": TimSmartBlowFish.encode(newPasswordConfirm),
  
    });
  },

  enablePassword(context: Action, { valuePassword }) {
    return api.post(`${enablePasswordChange}`);
  },

  verifyValuePasswordChange(context: Action) {
    return api.get(`${enablePasswordChange}`);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};